import Heading from '@/components/@base/typography/heading';
import Text from '@/components/@base/typography/text';

export { Heading, Text };
